import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import "./style.css";

function TextEditor({ data, handleChange }) {
  return (
    <CKEditor
      editor={ClassicEditor}
      config={{
        language: "fa",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
        ],
        link: {
          addTargetToExternalLinks: true,
          decorators: [
            {
              mode: "manual",
              label: "باز کردن در تب جدید",
              attributes: {
                target: "_blank",
              },
            },
          ],
        },
      }}
      data={data}
      onChange={(_, editor) => {
        const data = editor.getData();
        handleChange(data);
      }}
    />
  );
}

export default TextEditor;
